export const CELL_SPACE = 115 + 8;
export const tileSlideConfig = { stiffness: 210, damping: 18 };
export const tileNewConfig = { stiffness: 210, damping: 15 };



/** WEBPACK FOOTER **
 ** ./src/components/Tile/constants.js
 **/